module.exports = __webpack_public_path__ + "img/liveBroadcast_solution.43d4aa32.png";